<template>
  <div
    class="notification"
    :class="{ 'is-unread': isUnread, 'is-podcast-type': isTypePodcastAdvertisement }"
    @click="clickNotification"
  >
    <div
      v-if="notification.actor && notification.actor.guest"
      class="notification-avatar notification-avatar-guest"
    >
      訪
    </div>

    <img
      v-if="notification.actor && !notification.actor.guest"
      class="notification-avatar"
      :src="notification.actor.avatar_url"
    >

    <div
      v-if="isTypePodcastAdvertisement"
      class="notification-avatar notification-avatar-statementdog"
    >
      <svg>
        <use xlink:href="#svg-icon-statementdog-logo" />
      </svg>
    </div>

    <div class="notification-content">
      <span v-if="notification.event_type === 'NEW_INSIGHT_POST_RELATED_TO_MY_TRACKING_STOCKS'">
        <b>{{ notification.actor.name }} </b>
        發表了一篇和{{ notification.related_stocks[0].name }}有關的洞見文章：
        <b>{{ notification.subject.title }}</b>
      </span>

      <span v-if="notification.event_type === 'STATEMENTDOG_APPROVED_MY_INSIGHT_POST'">
        恭喜你！你的文章：<b>{{ notification.subject.title }} </b> 已經發佈在洞見上，
        你將獲得2個月的閱讀精選文章與參加洞見聚會權限
      </span>

      <span
        v-if="notification.event_type === 'STATEMENTDOG_APPROVED_MY_INSIGHT_POST_WITH_TOP_LEVEL'"
      >
        恭喜你！你的文章：<b>{{ notification.subject.title }} </b> 被選為洞見精選文章，
        你將獲得6個月的閱讀精選文章與參加洞見聚會權限
      </span>

      <span v-if="notification.event_type === 'USER_LIKED_MY_INSIGHT_POST'">
        <b>{{ notification.actor.name }} </b>
        推薦了你的文章：<b>{{ notification.subject.title }}</b>
      </span>

      <span v-if="notification.event_type === 'USER_LIKED_MY_INSIGHT_COMMENT'">
        <b>{{ notification.actor.name }} </b>
        推薦了你的一則留言：「{{ notification.subject.title }}」
      </span>

      <span v-if="notification.event_type === 'USER_COMMENTED_ON_MY_INSIGHT_POST'">
        <b>{{ notification.actor.name }} </b>
        回覆了你發表的一篇文章：<b>{{ notification.subject.title }}</b>
      </span>

      <span v-if="notification.event_type === 'USER_COMMENTED_ON_MY_COLLECTED_INSIGH_POST'">
        <b>{{ notification.actor.name }} </b>
        回覆了你收藏的一篇文章：<b>{{ notification.subject.title }}</b>
      </span>

      <span v-if="notification.event_type === 'USER_COMMENTED_ON_INSIGH_POST_COMMENTED_BY_ME'">
        <b>{{ notification.actor.name }} </b>
        回覆了你留言過的一篇文章：<b>{{ notification.subject.title }}</b>
      </span>
      <span v-if="isTypePodcastAdvertisement">
        財報狗 Podcast 新集數上線：<b>{{ notification.subject.podcast_episode_title }}</b>
      </span>

      <br>
      <span class="notification-date">{{ timeAgoFormat }}</span>

      <div
        v-if="isTypePodcastAdvertisement"
        class="notification-podcast-cta"
      >
        <a
          class="notification-podcast-cta-button"
          :href="notification.subject.apple_podcast_episode_url"
          target="_blank"
          @click.stop="clickPodcastCTAButton('Apple Podcast')"
        >
          <span class="notification-podcast-cta-icon">
            <svg>
              <use xlink:href="#svg-icon-apple-podcast-color" />
            </svg>
          </span>
          到 Apple Podcast 收聽
        </a>
        <a
          class="notification-podcast-cta-button"
          :href="notification.subject.spotify_episode_url"
          target="_blank"
          @click.stop="clickPodcastCTAButton('Spotify')"
        >
          <span class="notification-podcast-cta-icon">
            <svg>
              <use xlink:href="#svg-icon-spotify-color" />
            </svg>
          </span>
          到 Spotify 收聽
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { requestReadNotification } from '@/api/notification'

export default {
  props: {
    notification: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      hasSentReadEventBefore: false,
    }
  },
  computed: {
    isUnread() {
      return !this.notification.read && !this.hasSentReadEventBefore
    },
    isTypePodcastAdvertisement() {
      return this.notification.event_type === 'PODCAST_ADVERTISEMENT'
    },
    relatedStockName() {
      let name = '你追蹤過的公司'
      if (this.notification?.related_stocks?.length > 0) {
        [{ name }] = this.notification.related_stocks
      }

      return name
    },
    timeAgoFormat() {
      const iso8601 = this.notification.created_at
      const timeAgoWords = {
        seconds: '%d秒前',
        minute: '1分鐘前',
        minutes: '%d分鐘前',
        hour: '1小時前',
        hours: '%d小時前',
        day: '昨天',
      }

      let dateString = iso8601.trim()
      dateString = dateString.replace(/\.\d+/, '') // remove milliseconds
      dateString = dateString.replace(/-/, '/').replace(/-/, '/')
      dateString = dateString.replace(/T/, ' ').replace(/Z/, ' UTC')
      dateString = dateString.replace(/([+-]\d\d):?(\d\d)/, ' $1$2') // -04:00 -> -0400
      dateString = dateString.replace(/([+-]\d\d)$/, ' $100') // +09 -> +0900

      const pastDateObj = new Date(dateString)
      const currentDateObj = new Date()
      const distanceMillis = currentDateObj.getTime() - pastDateObj.getTime()
      const seconds = Math.abs(distanceMillis) / 1000
      const minutes = seconds / 60
      const hours = minutes / 60

      let words = ''
      if (seconds < 45) {
        words = timeAgoWords.seconds.replace(/%d/i, Math.round(seconds))
      } else if (seconds < 90) {
        words = timeAgoWords.minute
      } else if (minutes < 45) {
        words = timeAgoWords.minutes.replace(/%d/i, Math.round(minutes))
      } else if (minutes < 90) {
        words = timeAgoWords.hour
      } else if (hours < 24) {
        words = timeAgoWords.hours.replace(/%d/i, Math.round(hours))
      } else if (hours < 42) {
        words = timeAgoWords.day
      } else {
        let dateArray = iso8601.split('+')[0].split('T')
        dateArray = dateArray[0].split('-').concat(dateArray[1].split(':'))

        words = [
          currentDateObj.getFullYear() === parseInt(dateArray[0], 10) ? '' : [dateArray[0], '年'].join(''),
          parseInt(dateArray[1], 10), '月',
          parseInt(dateArray[2], 10), '日 ',
          dateArray[3], ':',
          dateArray[4],
        ].join('')
      }

      return words
    },
  },
  methods: {
    clickNotification() {
      if (this.isTypePodcastAdvertisement) {
        this.toggleNotifications()
        return
      }

      window.open(this.notification.subject.url)
      this.setReadStatusToTrue()
    },
    clickPodcastCTAButton(contentSource) {
      this.setReadStatusToTrue()
      this.requestPodcastClickedEvent(contentSource)
    },

    setReadStatusToTrue() {
      if (this.notification.read) {
        return
      }
      if (this.hasSentReadEventBefore) {
        return
      }

      this.hasSentReadEventBefore = true
      requestReadNotification({ notificationId: this.notification.id })
    },
    requestPodcastClickedEvent(contentSource) {
      window.amplitudeEvents.clickNotification({
        clickedFrom: window.location.href,
        contentType: 'podcast',
        contentSource,
        contentTitle: this.notification.subject.podcast_episode_title,
      })
    },
  },
}
</script>

<style scoped lang="scss">
.notification {
  display: flex;
  flex-direction: row;
  position: relative;
  padding: 12px;
  overflow: hidden;
  background: #FAFAFA;
  border-top:1px solid #e3e3e3;
  margin-top: -1px;
  font-size: 13px;
  font-weight: normal;
  line-height: 165%;
  color: #434343;
  cursor: pointer;

  &.is-unread{
    background: #eaf5fb;
  }
  &.is-unread:hover{
    background: #FFF;
  }
  &:hover {
    background: #EDEDED;
  }
  &.is-podcast-type {
    cursor: default;
  }

}
.notification-avatar {
  display: inline-flex;
  flex: 0 0 56px;
  width: 56px;
  height: 56px;
  margin: 3px 12px 0 0;
  text-align: center;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;

  &.notification-avatar-guest {
    background: #636363;
    color: #fff;
    font-size: 20px;
    font-weight: bold;
    line-height: 56px;
  }
}
.notification-content {
  display: table-cell;
  span {
    white-space: normal;
  }
}
.notification-date {
  color: #939393;
}

// Podcast ad
.notification-avatar-statementdog {
  width: 56px;
  height: 56px;

  svg {
    -moz-border-radius: 4px;
    -webkit-border-radius: 4px;
    border-radius: 4px;
    height: 100%;
    width: 100%;
  }
}

.notification-podcast-cta {
  display: flex;
  flex-wrap: nowrap;
  margin-top: 8px;
}
.notification-podcast-cta-button {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  padding: 8px;
  margin-right: 16px;
  color: #0386F4;
  font-weight: 600;
  line-height: 1.5;
  font-size: 14px;
  background: #fff;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.16);
  border: 1px solid rgba(0, 0, 0, 0);
  -moz-border-radius: 4px;
  -webkit-border-radius: 4px;
  border-radius: 4px;

  &:hover {
    background-color: #EAF5FB;
    border-color: #0386F4;
  }
}
.notification-podcast-cta-icon {
  display: inline-block;
  height: 24px;
  width: 24px;
  margin-right: 4px;

  svg {
    width: 100%;
    height: 100%;
  }
}
</style>
